export const REPO_OWNER = 'angular';
export const REPO_NAME = 'angular-cli';
